// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"TP-z","inlineTitle":"UP-z","sponsoredAdsWrapper":"VP-z","marketplaceRecosWrapper":"WP-z"};